import { createAction, props } from '@ngrx/store';

import { Feedback } from '@shared/models';

export const feedbackLoadSuccess = createAction(
  '[Feedback] Load Success',
  props<{ feedbackArray?: Feedback[] }>(),
);

export const feedbackLoadFail = createAction(
  '[Feedback] Load Fail',
  props<{ error?: any }>(),
);

export const feedbackCreate = createAction(
  '[Feedback] Create',
  props<{ feedback: Partial<Feedback> }>(),
);

export const feedbackCreateMany = createAction(
  '[Feedback] Create Many',
  props<{ feedbackArray: Feedback[] }>(),
);

export const feedbackCreateSuccess = createAction(
  '[Feedback] Create Success',
  props<{ feedback: Feedback }>(),
);

export const feedbackCreateManySuccess = createAction(
  '[Feedback] Create Many Success',
  props<{ feedbackArray: Feedback[] }>(),
);

export const feedbackCreateFail = createAction(
  '[Feedback] Create Fail',
  props<{ error: any }>(),
);
